module.exports = __webpack_public_path__ + "img/icon-arrow-down.7065d902.svg";